import script from "./ProfileStore.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileStore.vue?vue&type=script&setup=true&lang=js"

import "./ProfileStore.vue?vue&type=style&index=0&id=4708c5b8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4708c5b8"]])

export default __exports__